import React from "react";
import { Form, List, Space, Typography, Input, InputNumber, Row, Divider, Table, Select } from "antd";
import Decimal from "decimal.js";

const { Text, Title } = Typography;
const { Option } = Select;

/**
 * @description Sección de totales del complemento de pago
 */
const TotalesComplementoPagoSection = () => {
    const form = Form.useFormInstance();

    const impuestosPColumns = [
        {
            title: "BaseP",
            key: "BaseP",
            width: 120,
            render: () => (
                <Form.Item 
                    name={["Complemento", "Any", 0, "Pago20:Pagos", "Pago", 0, "ImpuestosP", "TrasladosP", 0, "BaseP"]}
                    noStyle
                >
                    <InputNumber
                        size="small"
                        style={{ width: "100%" }}
                        controls={false}
                        bordered={false}
                        formatter={(value) => {
                            if (!value) return "";
                            const parts = value.toString().split(".");
                            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            return `$ ${parts.join(".")}`;
                        }}
                        parser={(value) => value && value.replace(/\$\s?|(,*)/g, "")}
                        onChange={(value) => {
                            if (value) {
                                const baseP = new Decimal(value || 0);
                                const tasaOCuotaP = form.getFieldValue(["Complemento", "Any", 0, "Pago20:Pagos", "Pago", 0, "ImpuestosP", "TrasladosP", 0, "TasaOCuotaP"]) || "0";
                                const importeP = baseP.mul(new Decimal(tasaOCuotaP));
                                form.setFieldValue(["Complemento", "Any", 0, "Pago20:Pagos", "Pago", 0, "ImpuestosP", "TrasladosP", 0, "ImporteP"], importeP.toFixed(2));
                            }
                        }}
                    />
                </Form.Item>
            ),
        },
        {
            title: "ImpuestoP",
            key: "ImpuestoP",
            width: 150,
            render: () => (
                <Form.Item 
                    name={["Complemento", "Any", 0, "Pago20:Pagos", "Pago", 0, "ImpuestosP", "TrasladosP", 0, "ImpuestoP"]}
                    noStyle
                >
                    <Select bordered={false} size="small" style={{ width: "100%" }}>
                        <Option value="002">002 - IVA</Option>
                        <Option value="003">003 - IEPS</Option>
                    </Select>
                </Form.Item>
            ),
        },
        {
            title: "TipoFactorP",
            key: "TipoFactorP",
            width: 120,
            render: () => (
                <Form.Item 
                    name={["Complemento", "Any", 0, "Pago20:Pagos", "Pago", 0, "ImpuestosP", "TrasladosP", 0, "TipoFactorP"]}
                    noStyle
                >
                    <Select bordered={false} size="small" style={{ width: "100%" }}>
                        <Option value="Tasa">Tasa</Option>
                        <Option value="Cuota">Cuota</Option>
                        <Option value="Exento">Exento</Option>
                    </Select>
                </Form.Item>
            ),
        },
        {
            title: "TasaOCuotaP",
            key: "TasaOCuotaP",
            width: 120,
            render: () => (
                <Form.Item 
                    name={["Complemento", "Any", 0, "Pago20:Pagos", "Pago", 0, "ImpuestosP", "TrasladosP", 0, "TasaOCuotaP"]}
                    noStyle
                >
                    <Input 
                        bordered={false} 
                        size="small"
                        onChange={(e) => {
                            const tasaOCuotaP = e.target.value || "0";
                            const baseP = form.getFieldValue(["Complemento", "Any", 0, "Pago20:Pagos", "Pago", 0, "ImpuestosP", "TrasladosP", 0, "BaseP"]) || "0";
                            const importeP = new Decimal(baseP).mul(new Decimal(tasaOCuotaP));
                            form.setFieldValue(["Complemento", "Any", 0, "Pago20:Pagos", "Pago", 0, "ImpuestosP", "TrasladosP", 0, "ImporteP"], importeP.toFixed(2));
                        }}
                    />
                </Form.Item>
            ),
        },
        {
            title: "ImporteP",
            key: "ImporteP",
            width: 120,
            render: () => (
                <Form.Item 
                    name={["Complemento", "Any", 0, "Pago20:Pagos", "Pago", 0, "ImpuestosP", "TrasladosP", 0, "ImporteP"]}
                    noStyle
                >
                    <InputNumber
                        size="small"
                        style={{ width: "100%" }}
                        controls={false}
                        bordered={false}
                        formatter={(value) => {
                            if (!value) return "";
                            const parts = value.toString().split(".");
                            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                            return `$ ${parts.join(".")}`;
                        }}
                        parser={(value) => value && value.replace(/\$\s?|(,*)/g, "")}
                        readOnly
                    />
                </Form.Item>
            ),
        },
    ];

    return (
        <>
            <Row>
                <Divider orientation="left" style={{ margin: "12px 0 24px 0 " }} />
                <Title level={5}>Impuestos del Complemento de Pago</Title>
            </Row>
            
            <Table
                size="small"
                bordered
                pagination={false}
                scroll={{ x: 800 }}
                rowKey="key"
                columns={impuestosPColumns}
                dataSource={[{ key: "traslado-0" }]}
            />
                
            <Row>
                <Divider orientation="left" style={{ margin: "12px 0 24px 0 " }} />
                <Title level={5}>Totales</Title>
            </Row>
            <List className="list-totals" size="small" bordered={false}>
                {/* TotalTrasladosBaseIVA16 */}
                <List.Item>
                    <Space style={{ justifyContent: "space-between", width: "100%" }}>
                        <Text strong>Total Traslados Base IVA 16% <small>(MXN)</small></Text>
                        <Form.Item 
                            name={["Complemento", "Any", 0, "Pago20:Pagos", "Totales", "TotalTrasladosBaseIVA16"]}
                            noStyle
                        >
                            <InputNumber
                                size="large"
                                style={{ minWidth: 150, textAlign: 'right' }}
                                bordered={false}
                                controls={false}
                                formatter={(value) => {
                                    if (!value) return "";
                                    const parts = value.toString().split(".");
                                    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                    return `$ ${parts.join(".")}`;
                                }}
                                parser={(value) => value && value.replace(/\$\s?|(,*)/g, "")}
                            />
                        </Form.Item>
                    </Space>
                </List.Item>

                {/* TotalTrasladosImpuestoIVA16 */}
                <List.Item>
                    <Space style={{ justifyContent: "space-between", width: "100%" }}>
                        <Text strong>Total Traslados Impuesto IVA 16% <small>(MXN)</small></Text>
                        <Form.Item 
                            name={["Complemento", "Any", 0, "Pago20:Pagos", "Totales", "TotalTrasladosImpuestoIVA16"]}
                            noStyle
                        >
                            <InputNumber
                                size="large"
                                style={{ minWidth: 150, textAlign: 'right' }}
                                bordered={false}
                                controls={false}
                                formatter={(value) => {
                                    if (!value) return "";
                                    const parts = value.toString().split(".");
                                    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                    return `$ ${parts.join(".")}`;
                                }}
                                parser={(value) => value && value.replace(/\$\s?|(,*)/g, "")}
                            />
                        </Form.Item>
                    </Space>
                </List.Item>

                {/* MontoTotalPagos */}
                <List.Item>
                    <Space style={{ justifyContent: "space-between", width: "100%" }}>
                        <Text strong>Monto Total de Pagos <small>(MXN)</small></Text>
                        <Form.Item 
                            name={["Complemento", "Any", 0, "Pago20:Pagos", "Totales", "MontoTotalPagos"]}
                            noStyle
                            rules={[{ required: true, message: "Ingrese MontoTotalPagos" }]}
                        >
                            <InputNumber
                                size="large"
                                style={{ minWidth: 150, textAlign: 'right' }}
                                bordered={false}
                                controls={false}
                                formatter={(value) => {
                                    if (!value) return "";
                                    const parts = value.toString().split(".");
                                    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                    return `$ ${parts.join(".")}`;
                                }}
                                parser={(value) => value && value.replace(/\$\s?|(,*)/g, "")}
                            />
                        </Form.Item>
                    </Space>
                </List.Item>
            </List>
        </>
    );
};

export default TotalesComplementoPagoSection;
